import {useNavigate} from 'react-router-dom';
import {OnboardingLayout} from './OnboardingLayout';
import {Button, CategoryPill} from '@/components';
import {useUserStore} from '@/store';
import styles from './Onboarding.module.css';

const CATEGORIES = [
  {icon: '👗', label: 'Fashion'},
  {icon: '🧒', label: 'Kids'},
  {icon: '💄', label: 'Beauty'},
  {icon: '🏠', label: 'Home'},
  {icon: '📱', label: 'Electronics'},
  {icon: '⚽', label: 'Sports'},
  {icon: '🛒', label: 'Grocery'},
  {icon: '🐾', label: 'Pets'},
];

export function Categories() {
  const navigate = useNavigate();
  const {selectedCategories, toggleCategory} = useUserStore();

  return (
    <OnboardingLayout currentStep={2} totalSteps={4}>
      <h2 className={styles.stepTitle}>What do you shop for?</h2>
      <p className={styles.stepDescription}>
        Select the categories you'd like to see in your closet.
      </p>
      <div className={styles.categoryGrid}>
        {CATEGORIES.map((cat) => (
          <CategoryPill
            key={cat.label}
            icon={cat.icon}
            label={cat.label}
            selected={selectedCategories.includes(cat.label)}
            onClick={() => toggleCategory(cat.label)}
          />
        ))}
      </div>
      <div className={styles.buttonRow}>
        <Button onClick={() => navigate('/onboarding/connect-email')}>Continue</Button>
      </div>
    </OnboardingLayout>
  );
}
